import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postInitiativeExportStart } from '@api';

export const coreInitiativesExportPostAsyncSlice = createPostAsyncSlice({
	name: 'CoreInitiativesExport',
	receive: true,
	request: true,
	requestHandler: postInitiativeExportStart
});
